import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Button, Popup, Grid } from 'semantic-ui-react'
import { compose } from 'recompose'

import Container from './GroupsModuleContainer'
import Enhancer from './GroupsModuleEnhancer'
import StandardError from 'Components/StandardError'
import StandardLoader from 'Components/StandardLoader'
import { withPermissions } from 'Components/Permissions'

import ErrorMassive from 'Components/ErrorMassive'
import GroupsTable from 'Components/GroupsTable'
import PageHeaderRow from 'Components/PageHeaderRow'
import Pagination from 'Components/Pagination'

import * as styles from './styles'

class GroupsModule extends Component {
  static propTypes = {
    groups: PropTypes.array.isRequired,
    limit: PropTypes.number.isRequired,
    pagination: PropTypes.object.isRequired,
    setPage: PropTypes.func.isRequired,
    setSortBy: PropTypes.func.isRequired,
    showCreateGroupModal: PropTypes.func.isRequired,
    sortBy: PropTypes.string.isRequired,
    sortOrder: PropTypes.string.isRequired,
    toggleLimit: PropTypes.func.isRequired,
    toggleSortOrder: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  }

  handleSort = column => {
    const { setSortBy, sortBy, toggleSortOrder } = this.props

    if (sortBy === column) {
      toggleSortOrder()
    } else {
      setSortBy(column)
    }
  }

  render() {
    const { groups, pagination, setPage, showCreateGroupModal, sortBy, sortOrder, toggleSortOrder } = this.props

    return (
      <Grid>
        <PageHeaderRow title="Groups" />

        <Grid.Row columns={1}>
          <Grid.Column width={16}>
            <div style={styles.buttonGroup}>
              <Button.Group icon>
                <Popup content={'Create a new Group'} size="mini" trigger={<Button onClick={showCreateGroupModal} icon="add" />} />
              </Button.Group>
            </div>

            {groups.length > 0 && (
              <GroupsTable
                groups={groups}
                handleSort={this.handleSort}
                sortBy={sortBy}
                sortOrder={sortOrder}
                toggleSortOrder={toggleSortOrder}
              />
            )}

            {groups.length > 0 && (
              <div>
                <br />

                <Pagination itemName="group" items={pagination.total} page={pagination.page} pages={pagination.pages} setPage={setPage} />
              </div>
            )}

            <ErrorMassive enabled={groups.length === 0} message="No groups found." />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

const composed = compose(
  withPermissions('modules.groups'),
  Enhancer,
  Container,
  StandardLoader('Gathering groups…'),
  StandardError,
)

export default composed(GroupsModule)
